import React, { useCallback } from 'react';
import {
  TouchableWithoutFeedback,
  View,
  GestureResponderEvent,
} from 'react-native-web';
import { BrandColor } from '@styleseat/brand';
import { PaddingSize } from '@styleseat/ui';
import ConditionalWrapper from '../ConditionalWrapper';
import { clickable } from '../../../styles';

export type RadioProps = {
  borderWidth?: number;
  color?: string;
  height?: number;
  isSelected?: boolean;
  padding?: PaddingSize;
  selectedColor?: string;
  disabledColor?: string;
  justifyContent?: 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly';
  backgroundColor?: string;
  testID?: string;
  width?: number;
  disabled?: boolean;
  onToggle: (event: GestureResponderEvent) => void;
};

const RadioButton = ({
  borderWidth = 6,
  color = BrandColor.Ash,
  height = 16,
  isSelected = false,
  padding = 0,
  disabled,
  selectedColor = BrandColor.DarkBlue,
  disabledColor = BrandColor.Metal,
  width = 16,
  justifyContent = 'center',
  backgroundColor,
  onToggle,
  testID,
}: RadioProps) => {
  const Toggleable = useCallback((child: React.ReactNode) => (
    <TouchableWithoutFeedback onPress={onToggle} testID={testID}>
      {child}
    </TouchableWithoutFeedback>
  ), [
    onToggle,
    testID,
  ]);

  return (
    <ConditionalWrapper
      condition={!disabled}
      wrapper={Toggleable}
    >
      <View
        testID={testID}
        style={[
          {
            height: height + padding * 2,
            width: width + padding * 2,
            alignItems: 'center',
            justifyContent,
          },
          ...(disabled ? [] : [clickable]),
        ]}
      >
        <View
          testID={`${testID}-selectable`}
          dataSet={{ selected: isSelected }}
          style={[
            {
              height,
              width,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: color,
              borderStyle: 'solid',
              backgroundColor,
            },
            (
              isSelected && {
                borderWidth,
                borderColor: disabled ? disabledColor : selectedColor,
              }
            ),
          ]}
        />
      </View>
    </ConditionalWrapper>
  );
};

export default RadioButton;
